import $ from 'jquery';
import { Datepicker } from 'vanillajs-datepicker';
import de from 'vanillajs-datepicker/js/i18n/locales/de';

export default function datePicker() {
  const elem = document.querySelector('.datepicker-input');
  if (elem) {
    Object.assign(Datepicker.locales, de);
    let dateNow = new Date();
    let currentDate = new Date();
    let currentTime = addHoursToDate(currentDate, 24).getHours() + ':' + addHoursToDate(currentDate, 24).getMinutes();

    const currentDateDay = currentDate.getDate();
    const currentDateMonth = currentDate.getMonth();
    const currentDateYear = currentDate.getFullYear();

    function addHoursToDate(date, hours) {
      return new Date(new Date(date).setHours(date.getHours() + hours));
    }

    // currentDate.setDate(currentDate.getDate() + 1);

    dateNow = addHoursToDate(dateNow, 24);
    currentDate = addHoursToDate(currentDate, 24);

    if(dateNow.getDay() == 0) {
      dateNow.setDate(dateNow.getDate() + 1);
    }

    if(dateNow.getDay() == 6) {
      dateNow.setDate(dateNow.getDate() + 2);
    }

    if(dateNow.getDay() == 5) {
      dateNow.setDate(dateNow.getDate() + 3);
    }

    function disableTimes(el) {
      $('.ui-timepicker-viewport >*').each(function () {
        currentDate = addHoursToDate(currentDate, 24);

        let getTime = $(this).text();

        if (el == true) {
          if (getTime <= currentTime) {
            $(this).attr('disabled', 'true');
          }
        } else {
          if (getTime <= currentTime) {
            $(this).removeAttr('disabled');
          }
        }
      })
    }


    const datepicker = new Datepicker(elem, {
      buttonClass: 'btn',
      language: 'de',
      format: 'dd-mm-yyyy',
      daysOfWeekDisabled: [6,0],
      nextArrow: '>',
      prevArrow: '<',
      minDate: 0,
      defaultViewDate: dateNow,
    });

    let splitMonth = jQuery('.datepicker-controls .view-switch').html().split(' ');
    const getMonth = splitMonth[0];

    function disablePrevDays() {
      $(".datepicker-grid >*").each(function(){
        const currentNumber = $(this).text();

        if (currentNumber == currentDateDay) {
          // $(this).addClass('focused');
          $(this).addClass('prev');
          if(dateNow.getDay() == 0 || dateNow.getDay() == 6 || dateNow.getDay() == 5) {
            $(this).addClass('prev');
          }

          return false;
        }

        $(this).addClass('prev');
        $(this).removeClass('focused');
      });
    }

    disableTimes(true);


    disablePrevDays();

    let followingDay = new Date(dateNow.setDate(dateNow.getDate()));
    $('.datepicker-cell.day:not(.prev)').on("click", function() {
      let selectedMonth = jQuery('.datepicker-controls .view-switch').html().split(' ');
      let selectedday = jQuery(this).text();

      const current = followingDay.toLocaleDateString('default', { day: 'numeric',month: 'long',year: 'numeric' });
      const selectDate = selectedday + '. ' + selectedMonth[0] + ' ' + selectedMonth[1];

      if (current === selectDate) {
        disableTimes(true);
      } else {
        disableTimes(false);
      }

    });

    $('.datepicker-controls .prev-btn').on("click", function() {
      let selectedMonth = jQuery('.datepicker-controls .view-switch').html().split(' ');
      if (getMonth == selectedMonth[0]) {
        jQuery('.datepicker-controls .prev-btn').attr('disabled', 'true');
        disablePrevDays();
        disableTimes(true);
      }
    });

    $('.datepicker-controls .next-btn').on("click", function() {
      $('.datepicker-controls .prev-btn').removeAttr('disabled');
      disableTimes(false);
    });

    jQuery('.datepicker-controls .prev-btn').attr('disabled', 'true');
    jQuery('.datepicker-cell.day.focused').prev().addClass('prev');
  }
}
